var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,_vm._b({ref:"component",tag:"component",attrs:{"licenseRendererVm":_vm.licenseRendererVm,"licenseWrapper":_vm.licenseWrapper,"licenseItem":_vm.licenseItem,"value":_vm.value},on:{"input":function (ref) {
	var fieldName = ref[0];
	var fieldValue = ref[1];

	return _vm.$emit('input', [fieldName, fieldValue]);
}}},'component',_vm.$attrs,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9690b598","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Licenses/CommonLicenseComponents/index.vue
// module id = 641
// module chunks = 0 1 2 3